<template lang="pug">
    v-dialog(v-model="openModalNotif" hide-overlay  max-width="500px")
        v-card
            v-card-text
                v-alert(
                    class="pt-7"
                    style="margin-left :-25px; margin-right :-24px; margin-bottom :-20px"
                    dense
                    type="warning"          
                    ) {{ getMessage }}
                    br
                    v-btn(text  color="white" @click="closeModal" style="float: right") OK
</template>
<script>
import store from '../store';
export default {
    name: "ModalNotif",
    props: {
        'openModalNotif': {
            type: Boolean,
            default: false
        },
        'message': {
            type: String,
            default: ''
        }
    },
    computed: {
        getMessage(){
            return this.message !== '' ? this.message : `Ada Pembaharuan sistem iPermit, mohon untuk clear cache browser (tekan Ctrl+Shift+R secara bersamaan) sebelum relogin!`;
        }
    },
    methods: {
        closeModal (){
              store.dispatch('logout')
              this.$emit("closeModal", false);
              this.$router.push('/login') 
        }
    }
};
</script>